<template>
  <div class="not-found-wrap text-center">
    <h1 class="text-60">404</h1>
    <p class="text-36 subheading mb-3">Error!</p>
    <p class="mb-5 text-muted text-18">
      Sorry! The page you were looking for doesn't exist.
    </p>
    <router-link to="/">
      <a class="btn btn-lg btn-primary btn-rounded text-white"
        >Go back to home</a
      >
    </router-link>
  </div>
</template>

<script>
export default {
  name: "404",
  components: {},
};
</script>
